/* eslint-disable react/button-has-type */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon, { IconType, IconSize } from '../icon/icon';

export const ButtonType = {
  BUTTON: 'button',
  SUBMIT: 'submit',
  RESET: 'reset',
};

export const ButtonTheme = {
  PRIMARY: 'primary',
  PRIMARY_OUTLINE: 'outline-primary',
  SECONDARY: 'secondary',
  SECONDARY_OUTLINE: 'outline-secondary',
  SUCCESS: 'success',
  SUCCESS_OUTLINE: 'outline-success',
  WARNING: 'warning',
  WARNING_OUTLINE: 'outline-warning',
  ERROR: 'danger',
  ERROR_OUTLINE: 'outline-danger',
  INFO: 'info',
  INFO_OUTLINE: 'outline-info',
  LIGH: 'ligh',
  LIGH_OUTLINE: 'outline-danger',
  DARK: 'dark',
  DARK_OUTLINE: 'outline-danger',
  LINK: 'link',
  '': '',
};

export const ButtonSize = {
  BLOCK: 'block',
  LARGE: 'lg',
  SMALL: 'sm',
  MEDIUM: 'md',
  '': '',
};

/**
 * Button is a basic HTML button with text and/or icon.
 * It can change the theme background, size and bind to parent function.
 */
const Button = (props) => {
  const {
    id, type, theme, size, onClick, onBlur, children, className, icon, iconColor, iconSize, disabled,title,dataId
  } = props;
  const classProps = classNames(
    'btn',
    `btn-${theme}`,
    `btn-${size}`,
    className,
  );

  return (
    <button
      id={id}
      type={type}
      title={title}
      onClick={(e) => {e.stopPropagation(); onClick(e)}}
      onBlur={onBlur}
      disabled={disabled}
      className={classProps}
      data-id={dataId}
    >
      { icon !== ''
         && (
         <Icon
           icon={icon}
           iconSize={iconSize}
           iconColor={iconColor}
         />
         )}
      {children}
    </button>
  );
};

Button.propTypes = {
  /**
   * id of button
   */
  id: PropTypes.string,
  /**
   * HTML attribute type
   */
  type: PropTypes.oneOf(Object.values(ButtonType)),
  /**
   * Button background color
   */
  theme: PropTypes.oneOf(Object.values(ButtonTheme)),
  /**
   * Button general size
   */
  size: PropTypes.oneOf(Object.values(ButtonSize)),
  /**
   * Function to bind click HTML functionality
   */
  onClick: PropTypes.func,
  /**
   * Function to bind onBlur HTML functionality
   */
  onBlur: PropTypes.func,
  /**
   * Content to put inside the Button component
   */
  children: PropTypes.node,
  /**
   * CSS classes to customize button
   */
  className: PropTypes.string,
  /**
   * To select a icon inside the button
   */
  icon: PropTypes.oneOf(Object.values(IconType)),
  /**
   * Icon color inside the button
   */
  iconColor: PropTypes.string,
  /**
   * Icon size inside the button
   */
  iconSize: PropTypes.oneOf(Object.values(IconSize)),
  /**
   * To disable the button functionality
   */
  disabled: PropTypes.bool,
};

Button.defaultProps = {
  id: '',
  type: ButtonType.BUTTON,
  theme: ButtonTheme.LIGH,
  size: ButtonSize.SMALL,
  onClick: () => {},
  onBlur: () => {},
  children: null,
  className: '',
  icon: '',
  iconColor: '',
  iconSize: IconSize.SMALL,
  disabled: false,
};

export default Button;
